import CityPageTemplate from "../city-template/CityPageTemplate";
import { hendersonNvConfig } from "./data";

export default function HendersonNVPage() {
  return <CityPageTemplate config={hendersonNvConfig} />;
}